module.exports = __webpack_public_path__ + "static/media/Manual Paso a paso Cook-key (para clientes tm5).5e42d1fc.pdf";